import { ReactNode, useCallback, useReducer } from 'react';
import TableContext from './tableContext';
import tableReducer from './tableReducer';

const TableState: React.FC<ReactNode> = ({ children }) => {
    const setDataLength = useCallback(
        (length: number): void =>
            dispatch({
                type: 'SET_DATA_LENGTH',
                payload: length,
            }),
        []
    );

    const setInitialDataLength = useCallback(
        (length: number): void =>
            dispatch({
                type: 'SET_INITIAL_DATA_LENGTH',
                payload: length,
            }),
        []
    );

    const setCurPage = useCallback(
        (page: number): void =>
            dispatch({
                type: 'SET_CUR_PAGE',
                payload: page,
            }),
        []
    );

    const setPrevPage = useCallback(
        (page: number | null): void =>
            dispatch({
                type: 'SET_PREV_PAGE',
                payload: page,
            }),
        []
    );

    const setPagination = useCallback(
        (isPaginated: boolean, rowPerPage: number): void =>
            dispatch({
                type: 'SET_PAGINATION',
                payload: {
                    isPaginated,
                    rowPerPage,
                },
            }),
        []
    );

    const setNumOfColumns = useCallback(
        (numOfColumns: number): void =>
            dispatch({
                type: 'SET_NUMBER_OF_COLUMNS',
                payload: numOfColumns,
            }),
        []
    );

    const initialState = {
        curPage: 1,
        prevPage: null,
        pagination: false,
        dataLength: 0,
        initialDataLength: 0,
        numOfColumns: null,
        rowPerPage: 5,
        setDataLength,
        setInitialDataLength,
        setCurPage,
        setPrevPage,
        setPagination,
        setNumOfColumns,
    };

    const [state, dispatch] = useReducer(tableReducer, initialState);

    return (
        <TableContext.Provider
            value={{
                numOfColumns: state.numOfColumns,
                curPage: state.curPage,
                prevPage: state.prevPage,
                rowPerPage: state.rowPerPage,
                pagination: state.pagination,
                dataLength: state.dataLength,
                initialDataLength: state.initialDataLength,
                setCurPage,
                setPrevPage,
                setDataLength,
                setInitialDataLength,
                setPagination,
                setNumOfColumns,
            }}
        >
            {children}
        </TableContext.Provider>
    );
};

export default TableState;
